<div class="chart-title-container {{ dashboardData.dashboardGraphType }}">
    <span class="chart-title-icon {{ icon }}"></span>
    {{ dashboardData.translated }}
</div>
<div class="values-container">
    <mat-expansion-panel class="w-100 mt-1 chart-border" *ngFor="let value of dashboardData.data.values; let i = index">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="top-index mr-1">
                    {{ i + 1 }}.
                </div>
                <div class="d-flex justify-content-between w-100">
                    <div class="left">
                        {{ value[mainField] }}
                    </div>
                    <div class="right font-weight-light yellow-text">
                        {{ utilityService.thousandSeparator(value.orderedValue) }} KM
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list dense>
            <mat-list-item *ngFor="let field of fields" class="top-container {{ dashboardData.dashboardGraphType }}">
                <div class="top-header">{{ field.header | translate }}:</div>

                <div *ngIf="field.type == 'decimal'" class="top-value">{{  utilityService.thousandSeparator(value[field.value]) }}</div>
                <div *ngIf="field.type != 'decimal'" class="top-value">{{ value[field.value] }}</div>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>
</div>